var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.362,
    height: 16.174,
    viewBox: "0 0 16.362 16.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle_1_",
    "data-name": "check-circle (1)",
    transform: "translate(-1.208 -1.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9456",
    "data-name": "Path 9456",
    d: "M16.721,8.682v.677a7.36,7.36,0,1,1-4.365-6.727",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#20a253",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9457",
    "data-name": "Path 9457",
    d: "M18.568,4l-7.36,7.368L9,9.16",
    transform: "translate(-1.848 -0.53)",
    fill: "none",
    stroke: "#20a253",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.d343071e6eec525294c3229e3e74aa0e.svg";
export { ForwardRef as ReactComponent };